<template>
  <va-edit-layout>
    <state-form :id="id" :title="title" :item="item"></state-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
